import Navbar from "./pages/Components/Navigation/Navbar";
import LandingPage from "./pages/LandingPage";
import Footer from "./pages/Components/Footer/Footer";
import NavBottom from "./pages/Components/Navigation/NavBottom";

import MediaInformasi from "./pages/Components/Promo/MediaInformasi";
import TentangKami from "./pages/Components/TentangKami";
import HubungiKami from "./pages/Components/HubungiKami";
import FaQ from "./pages/Components/FaQ";

import PinjamanIndividu from "./pages/Components/Product/PinjamanIndividu/PinjamanIndividu";
import PinjamanProduktif from "./pages/Components/Product/PinjamanProduktif/PinjamanUsaha";
import FasilitasPendanaan from "./pages/Components/Product/Pendanaan";
import PerusahaanMitra from "./pages/Components/Product/PerusahaanMitra";

import Tnc from "./pages/Components/Tnc/Tnc.jsx";
import PernyataanPrivasi from "./pages/Components/Footer/PernyataanPrivasi";

import { Routes, Route } from "react-router-dom";
import PromoDetailPage from "./pages/Components/Promo/PromoDetailPage";

import PinjamanKaryawan from "./pages/Components/Product/PinjamanIndividu/PinjamanKaryawan";
import React from "react";
import KreditMultiGuna from "./pages/Components/Product/PinjamanIndividu/KreditMultiGuna";
import InvoiceFinancing from "./pages/Components/Product/PinjamanProduktif/InvoiceFinancing";
import InventoryFinancing from "./pages/Components/Product/PinjamanProduktif/InventoryFinancing";
import DeveloperFinancing from "./pages/Components/Product/PinjamanProduktif/DeveloperFinancing";
import AnalyticsTracker from "./AnalyticsTracker";
import WhistleBlowing from "./pages/Components/WhistleBlowing/WhistleBlowing";
import PublikasiPenangananPengaduan from "./pages/Components/PublikasiPenangananPengaduan";

function App() {
    return (
        <>
            <Navbar />
            <AnalyticsTracker />
            <Routes>
                <Route path="/" element={<LandingPage />} />
                {/* Navbar Side */}
                <Route path="media-informasi" element={<MediaInformasi />} />
                <Route path="tentang-kami" element={<TentangKami />} />
                <Route path="hubungi-kami" element={<HubungiKami />} />
                <Route path="faq" element={<FaQ />} />

                {/* Navbar Bottom */}
                <Route path="pinjaman-individu" element={<PinjamanIndividu />} />
                <Route path="pinjaman-usaha" element={<PinjamanProduktif/>} />
                <Route path="pendanaan" element={<FasilitasPendanaan />} />
                <Route path="perusahaan-mitra" element={<PerusahaanMitra />} />

                {/* Footer */}
                <Route path="tnc" element={<Tnc />} />
                <Route path="pernyataan-privasi" element={<PernyataanPrivasi />} />

                {/* remove this after complete */}
                <Route path="promo-detail" element={<PromoDetailPage />} />

                {/* Product Path*/}
                {/* <Route path="kasbon" element={<Kasbon/>}/> */}
                <Route path="employee-benefit-program" element={<PinjamanKaryawan/>}/>
                <Route path="kmg" element={<KreditMultiGuna/>}/>
                <Route path="invoice-financing" element={<InvoiceFinancing/>}/>
                <Route path="inventory-financing" element={<InventoryFinancing/>}/>
                <Route path="developer-financing" element={<DeveloperFinancing/>}/>

                {/* Another Path*/}
                <Route path="whistle-blowing" element={<WhistleBlowing/>}/>
                <Route path="publikasi-penanganan-pengaduan" element={<PublikasiPenangananPengaduan/>}/>
            </Routes>
            <Footer />
            <NavBottom />
        </>
    );
}

export default App;
